import { render, staticRenderFns } from "./GenerateLabels.vue?vue&type=template&id=bd4c8e06"
import script from "./GenerateLabels.vue?vue&type=script&lang=js"
export * from "./GenerateLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports